module.exports = __webpack_public_path__ + "img/empty-box.f3d8674c.svg";